import { call, put, takeLatest } from "redux-saga/effects";
import {
  ICampaignLeadGetType,
  ICampaignLeadLogTableType,
  IDispositionForm,
} from "../../../types/campaignTypes";
import {
  addCampaignLeadDispositionApi,
  getCampaignLeadByIdApi,
  getCampaignLeadDispositionApi,
} from "../requests/campaignRequests";
import {
  setCampaignLeadData,
  setLeadLogTable,
} from "../../slices/lead/campaignReducer";
import toast from "react-hot-toast";
import { setLoader } from "../../slices/feature/loader/loaderSlice";
import {
  addCampaignLeadDisposition,
  getCampaignLeadData,
  getCampaignLeadLogTable,
} from "../../actions/campaignActions";
import { getDispositionList } from "../../actions/tempActions";

interface getCampaignLeadInterface {
  type: string;
  payload: ICampaignLeadGetType;
}

interface addCampaignLeadDispoInterface {
  type: string;
  payload: IDispositionForm;
}
interface getCampaignLeadLogInterface {
  type: string;
  payload: ICampaignLeadLogTableType;
}

function* getCampaignLeadDataHandler(action: getCampaignLeadInterface): any {
  try {
    const { data } = yield call(getCampaignLeadByIdApi, action.payload);

    //get disposition data for the lead we get
    yield put(getDispositionList({ roles: data.role }));

    yield put(setCampaignLeadData(data));
  } catch (error: any) {
    toast.error(error?.response?.data?.message, { duration: 3000 });
  } finally {
    yield put(setLoader(false));
  }
}
function* getCampaignLeadLogHandler(action: getCampaignLeadLogInterface): any {
  try {
    const { data } = yield call(getCampaignLeadDispositionApi, action.payload);

    yield put(setLeadLogTable(data));
  } catch (error: any) {
    toast.error(error?.response?.data?.message, { duration: 3000 });
  } finally {
    yield put(setLoader(false));
  }
}

function* addCampaignLeadDispositionHandler(
  action: addCampaignLeadDispoInterface
): any {
  try {
    yield put(setLoader(true));
    const { data } = yield call(addCampaignLeadDispositionApi, action.payload);
    console.log(data);
    toast.success(data?.msg, { duration: 3000 });
  } catch (error: any) {
    toast.error(error?.response?.data?.message, { duration: 3000 });
  } finally {
    yield put(setLoader(false));
  }
}

export default function* campaignSaga() {
  yield takeLatest(getCampaignLeadData.type, getCampaignLeadDataHandler);
  yield takeLatest(
    addCampaignLeadDisposition.type,
    addCampaignLeadDispositionHandler
  );
  yield takeLatest(
    getCampaignLeadLogTable.type,
    getCampaignLeadLogHandler
  );
  
}
